import React from 'react';

import Plan from './plan/Plan';
import Anchor from '@/components/common/anchor/Anchor';
import SectionHeader from '@/components/common/sectionHeader/SectionHeader';
import Spacer from '@/components/common/spacer/Spacer';

import './Pricing.css';

interface PricingProps {
  showHeader?: boolean;
  header?: string;
}

const Pricing: React.FC<PricingProps> = ({
  showHeader = true,
  header = 'Pricing'
}) => {
  const plans = [
    {
      title: 'Solo',
      description: 'For clinics with 1-2 dentists',
      originalPrice: 999,
      price: 299,
      discountPercentage: 70,
      isPopular: false
    },
    {
      title: 'Team',
      description: 'For clinics with 3-6 dentists',
      originalPrice: 1299,
      price: 399,
      discountPercentage: 70,
      isPopular: true
    },
    {
      title: 'Enterprise',
      description: 'For clinics with 7+ dentists',
      originalPrice: 1499,
      price: 499,
      discountPercentage: 70,
      isPopular: false
    }
  ];

  return (
    <div id="pricing">
      <Anchor id="toPricing" />
      {showHeader && <SectionHeader>{header}</SectionHeader>}
      <Spacer top={16} />
      <div className="plansContainer">
        {plans.map((plan, index) => (
          <Plan
            key={index}
            title={plan.title}
            description={plan.description}
            originalPrice={plan.originalPrice}
            price={plan.price}
            discountPercentage={plan.discountPercentage}
            isPopular={plan.isPopular}
          />
        ))}
      </div>
    </div>
  );
};

export default Pricing;
